import { Link } from "react-router-dom";
export default function Brand({ admin = false }: { admin?: boolean }) {
  return (
    <Link
      className="brand"
      to={admin ? "/admin" : "/"}
      aria-label={admin ? "ReachAtlas Admin" : "ReachAtlas home"}
    >
      <span className="brand-mark" aria-hidden="true">
        <svg viewBox="0 0 32 32" fill="none">
          <path
            d="m16 3 12 7v12l-12 7-12-7V10L16 3Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path d="m22 10-4 10-8 3 4-11 8-2Z" fill="currentColor" />
          <circle cx="16" cy="16" r="2" fill="#102c30" />
        </svg>
      </span>
      <span>
        Reach<span className="brand-accent">Atlas</span>
        {admin && <small>Admin</small>}
      </span>
    </Link>
  );
}
